import * as yup from 'yup';

export const artistProfileSchema = yup.object().shape({
  artistName: yup.string().required('Please enter your artist name'),
  hometown: yup.string().required('Please enter your hometown'),
});
